import React from "react";
import {Image} from 'react-bootstrap';
import Media from 'react-media';

import "./Summary.css";

import bg_summary from "../../asset/images/bg_summary.png";
import logo_summary from "../../asset/images/logo_summary.png";

//涵智博雅简介
class Summary extends React.Component {
  render() {
    return (
      <div>
          <Media query="(min-width: 900px)" render={() =>
            (
              <div className="summary">
                <div className="summary_bk">
                  <Image src={bg_summary} className="summary_bk_img" />
                  <div className="summary_content">
                    <Image src={logo_summary} className="summary_content_logo" />
                    <div className="summary_content_word">
                      <div className="summary_content_title">涵智博雅</div>
                      <div className="summary_content_p">
                        北京涵智博雅能源科技有限公司是一家致力于工业能源及工业物联网领域的科技型综合能源服务公司，公司通过持续的技术开发及应用，为用户动力系统提供全生命周期的定制化整体解决方案。公司总部位于北京，在上海、哈尔滨、苏州均设有分支机构，其业务覆盖华北、华东、华中地区。
                      </div>
                      <div className="summary_content_p">
                        中国节能协会节能服务产业委员会-节能服务产业重合同守信用企业
                      </div>
                      <div className="summary_content_p">
                        中国节能协会节能服务产业委员会成员单位
                      </div>
                      <div className="summary_content_p">
                        上海交通大学产学研合作单位
                      </div>
                      <div className="summary_content_p">
                        国家级高新技术企业
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
          <Media query="(max-width: 901px)" render={() =>
            (
              <div className="summary">
                <div className="summary_bk">
                  <div className="summary_content">
                    <div className="logo_summary">
                    </div>
                    <div className="summary_content_word">
                      <div className="summary_content_title">涵智博雅</div>
                      <div className="summary_content_p">
                        北京涵智博雅能源科技有限公司是一家致力于工业能源及工业物联网领域的科技型综合能源服务公司，公司通过持续的技术开发及应用，为用户动力系统提供全生命周期的定制化整体解决方案。公司总部位于北京，在上海、哈尔滨、苏州均设有分支机构，其业务覆盖华北、华东、华中地区。
                      </div>
                      <div className="summary_content_p">
                        中国节能协会节能服务产业委员会-节能服务产业重合同守信用企业
                      </div>
                      <div className="summary_content_p">
                        中国节能协会节能服务产业委员会成员单位
                      </div>
                      <div className="summary_content_p">
                        上海交通大学产学研合作单位
                      </div>
                      <div className="summary_content_p">
                        国家级高新技术企业
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          />

      </div>
    )
  }
}

export default Summary
